import util from '../util';

const root = () => util.GetFunctionRoot();

function headers(withBody) {
  const h = { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') };
  if (withBody) h['Content-Type'] = 'application/json';
  return h;
}

async function request(method, url, body) {
  const res = await fetch(`${root()}${url}`, {
    method,
    headers: headers(body !== undefined),
    credentials: 'include',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  return { status: res.status, ok: res.ok, data };
}

const enc = encodeURIComponent;
const repoBase = (o, r) => `/api/git/repos/${enc(o)}/${enc(r)}`;

export const gitApi = {
  request,
  listRepos: (filter, q) => request('GET', `/api/git/repos?filter=${enc(filter || 'all')}&q=${enc(q || '')}`),
  search: (q) => request('GET', `/api/git/search?q=${enc(q || '')}`),
  getRepo: (o, r) => request('GET', repoBase(o, r)),
  createRepo: (body) => request('POST', '/api/git/repos', body),
  updateRepo: (o, r, body) => request('PATCH', repoBase(o, r), body),
  deleteRepo: (o, r) => request('DELETE', repoBase(o, r)),
  getTree: (o, r, ref, path) => request('GET', `${repoBase(o, r)}/tree?ref=${enc(ref || '')}&path=${enc(path || '')}`),
  getBlob: (o, r, ref, path) => request('GET', `${repoBase(o, r)}/blob?ref=${enc(ref || '')}&path=${enc(path || '')}`),
  rawUrl: (o, r, ref, path) => `${root()}${repoBase(o, r)}/raw?ref=${enc(ref || '')}&path=${enc(path || '')}`,
  getCommits: (o, r, ref, page, limit) => request('GET', `${repoBase(o, r)}/commits?ref=${enc(ref || '')}&page=${page || 1}&limit=${limit || 30}`),
  getCommit: (o, r, oid) => request('GET', `${repoBase(o, r)}/commit/${enc(oid)}`),
  getDiff: (o, r, from, to) => request('GET', `${repoBase(o, r)}/diff?from=${enc(from || '')}&to=${enc(to || '')}`),
  getBranches: (o, r) => request('GET', `${repoBase(o, r)}/branches`),
  createBranch: (o, r, body) => request('POST', `${repoBase(o, r)}/branches`, body),
  deleteBranch: (o, r, name) => request('DELETE', `${repoBase(o, r)}/branches/${enc(name)}`),
  commitFile: (o, r, body) => request('POST', `${repoBase(o, r)}/commit`, body),
  getCollaborators: (o, r) => request('GET', `${repoBase(o, r)}/collaborators`),
  invite: (o, r, body) => request('POST', `${repoBase(o, r)}/collaborators`, body),
  removeCollaborator: (o, r, username) => request('DELETE', `${repoBase(o, r)}/collaborators/${enc(username)}`),
  getInvitations: () => request('GET', '/api/git/invitations'),
  respondInvitation: (id, accept) => request('POST', `/api/git/invitations/${enc(id)}/${accept ? 'accept' : 'decline'}`),
  listTokens: () => request('GET', '/api/auth/tokens'),
  createToken: (body) => request('POST', '/api/auth/tokens', body),
  revokeToken: (id) => request('DELETE', `/api/auth/tokens/${enc(id)}`),
};

export default gitApi;
